import React from 'react'
import PropTypes from 'prop-types'
import { Root } from './AppBar.styles'

/**
 * The AppBar's component.
 */
const AppBar = props => {
  const { children, position, tabsCount } = props

  return (
    <Root elevation={0} position={position} tabsCount={tabsCount}>
      {children}
    </Root>
  )
}

AppBar.defaultProps = {
  position: 'static'
}
AppBar.propTypes = {
  children: PropTypes.node.isRequired,
  tabsCount: PropTypes.number.isRequired,
  position: PropTypes.oneOf(['absolute', 'fixed', 'relative', 'static', 'sticky'])
}

export default AppBar
